import {getCurrentTheme} from '&/utils/app';

export default {
	app: {
		theme: getCurrentTheme(),
		loading: true,
		error: null,
		notFound: false,
	},
	auth: {
		isAuth: false,
		isAdmin: false,
		user: null,
		token: null,
	},
	articles: {
		all: [],
		end: false,
	},
	door: {
		isUnlock: false,
	},
};
